import awsconfig from 'client/aws-exports';
import config from 'client/shared/config';

import { Amplify } from 'aws-amplify';
import { CookieStorage } from 'aws-amplify/utils';
import { cognitoUserPoolsTokenProvider } from 'aws-amplify/auth/cognito';

Amplify.configure(awsconfig);

cognitoUserPoolsTokenProvider.setKeyValueStorage(
	new CookieStorage({
		domain: config.cookieDomain, // Ensure this matches your domain
		path: '/',
		expires: 365, // Cookie expiration in days
		secure: !config.isDev, // Cookies are sent over HTTPS only
		sameSite: 'lax', // Adjust based on your requirements ('lax' or 'none')
	})
);